// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Wo-z","badgeLink":"Xo-z","category":"Yo-z"};